import { render, staticRenderFns } from "./spanish_alphabet.vue?vue&type=template&id=11262d04&scoped=true"
import script from "./spanish_alphabet.vue?vue&type=script&lang=js"
export * from "./spanish_alphabet.vue?vue&type=script&lang=js"
import style0 from "./spanish_alphabet.vue?vue&type=style&index=0&id=11262d04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11262d04",
  null
  
)

export default component.exports